(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-sidebar"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-scl-style-variant"]) return;
  try {
    

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {

      super.hide();
      window.pauseAllMedia();
      let activeImage = document.querySelector(".active");
      let mainImage = document.querySelector(".main-image-wrap img");
      if(mainImage && activeImage){
        mainImage["srcset"] = activeImage["srcset"];
        mainImage.src = activeImage.src;
      }
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if(activeMedia){
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-tiger-eloise"]) return;
  try {
    

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {

      super.hide();
      window.pauseAllMedia();
      let activeImage = document.querySelector(".active");
      let mainImage = document.querySelector(".main-image-wrap img");
      if(mainImage.src && activeImage.src){
        mainImage["srcset"] = activeImage["srcset"];
        mainImage.src = activeImage.src;
      }
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if(activeMedia){
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {

      super.hide();
      window.pauseAllMedia();
      let activeImage = document.querySelector(".active");
      let mainImage = document.querySelector(".main-image-wrap img");
      if(mainImage && activeImage){
        mainImage["srcset"] = activeImage["srcset"];
        mainImage.src = activeImage.src;
      }
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if(activeMedia){
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  class ProductDetailsBuilder extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.parseDescription();
    }

    parseDescription() {
      const productDescription = this.querySelector('.productDescription');
      if (!productDescription) return;

      // Check if structured data already exists
      const existingElements = ['productDimensions', 'productDetails'];
      const hasExistingStructure = existingElements.some(className => 
        this.querySelector(`.${className}`)
      );

      // Only parse if structured data doesn't exist
      if (!hasExistingStructure) {
        const descriptionHTML = productDescription.innerHTML;
        
        // Find all p elements and look for "Dimensions", "Details", and "Materials" titles
        const pElements = productDescription.querySelectorAll('p');
        let dimensionsContent = '';
        let detailsContent = '';
        let materialsContent = '';
        let cleanedHTML = descriptionHTML;

        pElements.forEach(p => {
          const textContent = p.textContent.trim();
          
          if (textContent === 'Dimensions') {
            // Get the next sibling element (wrapper) after this p
            const nextElement = p.nextElementSibling;
            if (nextElement) {
              // Extract HTML content from the wrapper element including the wrapper itself
              dimensionsContent = nextElement.outerHTML.trim();
              // Remove both the title p and the wrapper element from cleaned HTML
              cleanedHTML = cleanedHTML.replace(p.outerHTML, '').replace(nextElement.outerHTML, '');
            }
          } else if (textContent === 'Details') {
            // Get the next sibling element (wrapper) after this p
            const nextElement = p.nextElementSibling;
            if (nextElement) {
              // Extract HTML content from the wrapper element including the wrapper itself
              detailsContent = nextElement.outerHTML.trim();
              // Remove both the title p and the wrapper element from cleaned HTML
              cleanedHTML = cleanedHTML.replace(p.outerHTML, '').replace(nextElement.outerHTML, '');
            }
          } else if (textContent === 'Materials') {
            // Get the next sibling element (wrapper) after this p
            const nextElement = p.nextElementSibling;
            if (nextElement) {
              // Extract HTML content from the wrapper element including the wrapper itself
              materialsContent = nextElement.outerHTML.trim();
              // Remove both the title p and the wrapper element from cleaned HTML
              cleanedHTML = cleanedHTML.replace(p.outerHTML, '').replace(nextElement.outerHTML, '');
            }
          }
        });

        // Create accordion sections for each found content
        const sections = [
          { title: 'Dimensions', content: dimensionsContent, className: 'productDimensions' },
          { title: 'Details', content: detailsContent, className: 'productDetails' },
          { title: 'Materials', content: materialsContent, className: 'productDetails' }
        ];

        sections.forEach(section => {
          if (section.content) {
            // Create accordion structure
            const accordionDiv = document.createElement('div');
            accordionDiv.className = 'product__accordion accordion';
            
            const detailsElement = document.createElement('details');
            
            const summaryElement = document.createElement('summary');
            summaryElement.innerHTML = `
              <div class="summary__title">
                <div class="h4 accordion__title">${section.title}</div>
              </div>
            `;
            
            const contentDiv = document.createElement('div');
            contentDiv.className = 'accordion__content rte';
            contentDiv.innerHTML = section.content;
            
            detailsElement.appendChild(summaryElement);
            detailsElement.appendChild(contentDiv);
            accordionDiv.appendChild(detailsElement);
            
            // Append accordion after product description
            productDescription.parentNode.insertBefore(accordionDiv, productDescription.nextSibling);
          }
        });

        // Create Description accordion with remaining content
        const remainingContent = cleanedHTML.trim();
        if (remainingContent) {
          const accordionDiv = document.createElement('div');
          accordionDiv.className = 'product__accordion accordion';
          
          const detailsElement = document.createElement('details');
          
          const summaryElement = document.createElement('summary');
          summaryElement.innerHTML = `
            <div class="summary__title">
              <div class="h4 accordion__title">Description</div>
            </div>
          `;
          
          const contentDiv = document.createElement('div');
          contentDiv.className = 'accordion__content rte';
          contentDiv.innerHTML = remainingContent;
          
          detailsElement.appendChild(summaryElement);
          detailsElement.appendChild(contentDiv);
          accordionDiv.appendChild(detailsElement);
          
          // Append Description accordion after product description
          productDescription.parentNode.insertBefore(accordionDiv, productDescription.nextSibling);
        }

        // Remove the original product description element since content is now in accordions
        // this.querySelector('.dimensionsTitle').remove();
        productDescription.remove();
      }
    }
  }

  customElements.define('product-details-builder', ProductDetailsBuilder);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiger-eloise-footer"]) return;
  try {
    

const footerBlockHeading = document.querySelectorAll('.footer-block--menu .footer-block__heading');
footerBlockHeading.forEach((heading) => {
  heading.addEventListener('click', () => {
    heading.parentNode.classList.toggle('open');
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tile-carousel"] && !Shopify.designMode) return;
  try {
    
  function isInViewport() {
    document.querySelectorAll('.slide').forEach(block => {
      let distance = block.getBoundingClientRect();
      let isInView = distance.left < (window.innerWidth || document.documentElement.clientWidth) && distance.right > 0;
      if (isInView){
        block.parentElement.setAttribute('aria-hidden', false);
      } else {
        block.parentElement.setAttribute('aria-hidden', true);
      }
    });
  }

  isInViewport();

  document.querySelectorAll('.next').forEach(next => {
    next.addEventListener('click', () => {
      isInViewport();
    });
  });

  document.querySelectorAll('.prev').forEach(prev => {
    prev.addEventListener('click', () => {
      isInViewport();
    });
  });

  document.querySelectorAll('.slide').forEach(block => {
    block.addEventListener('focus', () => {
      block.parentElement.setAttribute('aria-hidden', false);
    });
  });


  } catch(e) { console.error(e); }
})();
})();
